import type {
  DesignerDetail,
  DesignerPagedResult,
  SlugTranslation,
} from '~/types/api'
import type { QueryParams } from '~/types/api'
import { APIFilters } from '~/utils/APIFilters'

export function createDesignersRepository() {
  const { $api } = useNuxtApp()
  const { get } = baseRepository($api)

  const DOMAIN = 'designers'
  const DOMAIN_TRANSLATE = 'translate'

  async function getAll(params?: QueryParams) {
    if (!params) {
      params = {
        sort: APIFilters.makeSort({ weight: 'ASC', nid: 'DESC' }),
      }
    }
    return get<DesignerPagedResult>([DOMAIN], { params })
  }

  async function getAllPagination(page: number, itemsPerPage: number) {
    const params = {
      page,
      itemsPerPage,
      sort: APIFilters.makeSort({ weight: 'ASC', nid: 'DESC' }),
    }
    return get<DesignerPagedResult>([DOMAIN], { params })
  }

  async function getByNid(nid: number) {
    return get<DesignerDetail>([DOMAIN, nid])
  }

  async function getBySlug(slug: number) {
    return get<DesignerDetail>([DOMAIN, slug])
  }

  async function getByLine(lineTitle: string) {
    const params = {
      filter: APIFilters.makeFilter([
        {
          [APIFilterOP.EQUALS]: {
            'productLines.title': lineTitle,
          },
        },
      ]),
    }
    return get<DesignerPagedResult>([DOMAIN], { params })
  }

  async function translateSlug(slug: string) {
    return get<SlugTranslation>([DOMAIN, slug, DOMAIN_TRANSLATE])
    // TODO: langPath: ['base', LANG],
  }

  return {
    getAll,
    getAllPagination,
    getByNid,
    getBySlug,
    getByLine,
    translateSlug,
  }
}
